<template> 
  <div class="router-front"></div>
  <div class="router">
  
  <router-view v-slot="{ Component, route }">
  <transition name="fade" mode="out-in">
    <component :is="Component" :key="route.path" />
  </transition>
</router-view>
  </div> 
  <div  class="router-backend"></div>
  </template>
  <script setup>
  import {reactive,provide,onMounted,watch,watchEffect,ref,computed,nextTick,readonly,toRaw,markRaw} from "vue";
  import * as vueUse from "@vueuse/core";
  import Language from "@/hooks/language.js";
  import Router from "@/hooks/router.js";
  import bridge from "@/utils/sdkBridge.js";
  import * as request from "@/api/request";
  import * as utils from "@/utils";
  import * as _ from "lodash-es";
  import { useRoute } from 'vue-router';
 

 const route = useRoute();
      const { initLang ,curLang, getLangTxt, langData} = Language();

      const routerData = {};
      const compData = {};
      const PAGE_DATA_LANG = {"default":{"isLogin":false,"host":utils.getMainHost(),"pageId":"page-view"},"zh-CN":{"isLogin":false,"host":utils.getMainHost(),"pageId":"page-view"}};
      const pageData = reactive(PAGE_DATA_LANG[curLang] || PAGE_DATA_LANG['zh-CN']||{});
      let pagePlatform = "global"
      let pagePlatformId = 8;

      provide("pageData", pageData);

      if(pageData.gameId!==void 0 ){
        pageData.gameId = utils.getUrlParams("gameId") ||  utils.getUrlParams("gameID") ||  utils.getUrlParams("game_id") || pageData.gameId || ""
      }

      initLang();
      // 自定义setup - 开始
      const viewportWidth = window.innerWidth < window.innerHeight ? 750 : 'device-width'
document.getElementsByName(
      "viewport"
    )[0].content = `width=${viewportWidth},user-scalable=no`;


if(utils.getUrlParams("aid")=='mayileichong1121'){
try{
document.body.style.backgroundColor="black"
}catch(e){}
}
      // 自定义setup - 结束


  </script>
  <style lang="scss">
    @import 'assets/common.scss';

    #app{height:100%}
@media screen and (orientation:portrait) { 
 #u_c_YFC217{width:100vw}
}
@media screen and (orientation:landscape) {
 #u_c_YFC217{width:50vw;max-width:750px}
 }
html, body {
height: 100%;
}
  </style>
  